import Heading from 'LearningManager/components/Heading';
import {
	OptionCardProps,
	options
} from 'LearningManager/constants/createAssignment.constant';
import styles from 'LearningManager/styles/CustomSetup.module.scss';
import classNames from 'classnames';
import { FC, useMemo } from 'react';
import { useStepper } from 'LearningManager/hooks/Stepper.context';

const AssignUsers: FC = () => {
	const {
		draft: {
			customSetup: { selectedAssignUsersOptionId }
		},
		setSelectedAssignUsersOptionId
	} = useStepper();

	const SelectedComponent = useMemo(() => {
		const selectedOption = options.find(
			(item) => item.id === selectedAssignUsersOptionId
		);
		return selectedOption?.component || null;
	}, [selectedAssignUsersOptionId]);

	return (
		<div className={styles['assign-users']}>
			<Heading
				title="Assign Users"
				subHeading="Select the users who will take this training"
			/>
			<div className={styles.selection}>
				<div className={styles['selection--heading']}>
					Selection Method <span className={styles.star}>*</span>
				</div>
				<div className={styles.methods}>
					{options.map((opt) => (
						<OptionCard
							key={opt.id}
							selectedId={selectedAssignUsersOptionId}
							toggleSelect={setSelectedAssignUsersOptionId}
							{...opt}
						/>
					))}
				</div>
				{SelectedComponent}
			</div>
		</div>
	);
};

const OptionCard: FC<OptionCardProps> = ({
	selectedId,
	toggleSelect,
	id,
	icon,
	desc,
	title
}) => {
	const isSelected = selectedId === id;

	return (
		<div
			className={classNames(styles.card, {
				[styles['card--selected']]: isSelected
			})}
			onClick={() => toggleSelect(id)}
		>
			<div className={styles.label}>
				{icon}
				<div className={styles.head}>{title}</div>
			</div>
			<div className={styles.value}>{desc}</div>
		</div>
	);
};

export default AssignUsers;
